import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOutlinedInboxIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			x: 4,
			y: 4,
			width: 16,
			height: 16,
			rx: 2,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.25 13.75H17.3105L14.5303 16.5303C14.3896 16.6709 14.1989 16.75 14 16.75H10C9.80109 16.75 9.61038 16.6709 9.46973 16.5303L6.68945 13.75H4.75V18C4.75 18.3315 4.88179 18.6494 5.11621 18.8838C5.35063 19.1182 5.66848 19.25 6 19.25H18C18.3315 19.25 18.6494 19.1182 18.8838 18.8838C19.1182 18.6494 19.25 18.3315 19.25 18V13.75ZM19.25 6C19.25 5.66848 19.1182 5.35063 18.8838 5.11621C18.6494 4.88179 18.3315 4.75 18 4.75H6C5.66848 4.75 5.35063 4.88179 5.11621 5.11621C4.88179 5.35063 4.75 5.66848 4.75 6V12.25H7C7.19891 12.25 7.38962 12.3291 7.53027 12.4697L10.3105 15.25H13.6895L16.4697 12.4697L16.584 12.376C16.7063 12.2944 16.8508 12.25 17 12.25H19.25V6ZM20.75 18C20.75 18.7293 20.4601 19.4286 19.9443 19.9443C19.4286 20.4601 18.7293 20.75 18 20.75H6C5.27065 20.75 4.57139 20.4601 4.05566 19.9443C3.53994 19.4286 3.25 18.7293 3.25 18V6C3.25 5.27065 3.53994 4.57139 4.05566 4.05566C4.57139 3.53994 5.27065 3.25 6 3.25H18C18.7293 3.25 19.4286 3.53994 19.9443 4.05566C20.4601 4.57139 20.75 5.27065 20.75 6V18Z",
			fill: "#30515B"
		})
	]
});
const ForwardRef = forwardRef(SvgOutlinedInboxIcon);
const Memo = memo(ForwardRef);
export default Memo;
